import SectionLabel from './SectionLabel';

export default function PublicPageHeader({ eyebrow, title, description, tone = 'primary', children }) {
  return (
    <div className="mx-auto max-w-5xl px-4 pt-6 sm:px-6 sm:pt-10">
      {eyebrow && <SectionLabel tone={tone}>{eyebrow}</SectionLabel>}
      <h1 className="mt-4 max-w-3xl text-[2.35rem] font-medium leading-[1.04] tracking-[-0.035em] text-md-on-surface sm:text-[3.25rem]">{title}</h1>
      {description && <p className="mt-3 max-w-2xl text-base leading-7 text-md-on-surface-variant">{description}</p>}
      {children}
    </div>
  );
}
